import { render, staticRenderFns } from "./lingprint.vue?vue&type=template&id=67fce458&"
import script from "./lingprint.vue?vue&type=script&lang=js&"
export * from "./lingprint.vue?vue&type=script&lang=js&"
import style0 from "./lingprint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports